
<div v-if="isLandscape" class="cp-orientation">
  <div class="horizon-box">
    <div class="horizon-pic"><i /></div>
    <span>为了更好的体验，请将手机竖过来哦~</span>
  </div>
</div>
